/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A property linked to an organization, enriched with the per-link role.
 * @export
 * @interface OrganizationLinkedProperty
 */
export interface OrganizationLinkedProperty {
    /**
     * 
     * @type {number}
     * @memberof OrganizationLinkedProperty
     */
    readonly id: number;
    /**
     * PA firm that owns this record
     * @type {number}
     * @memberof OrganizationLinkedProperty
     */
    companyId: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    streetAddress: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    unit?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    notes?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationLinkedProperty
     */
    createdBy: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationLinkedProperty
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationLinkedProperty
     */
    readonly updatedAt: Date;
    /**
     * Role of this property for the organization (from the organization-property link).
     * @type {string}
     * @memberof OrganizationLinkedProperty
     */
    role?: string | null;
}

/**
 * Check if a given object implements the OrganizationLinkedProperty interface.
 */
export function instanceOfOrganizationLinkedProperty(value: object): value is OrganizationLinkedProperty {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('streetAddress' in value) || value['streetAddress'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OrganizationLinkedPropertyFromJSON(json: any): OrganizationLinkedProperty {
    return OrganizationLinkedPropertyFromJSONTyped(json, false);
}

export function OrganizationLinkedPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationLinkedProperty {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyId': json['companyId'],
        'streetAddress': json['streetAddress'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'city': json['city'],
        'state': json['state'],
        'zipCode': json['zipCode'],
        'country': json['country'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdBy': json['createdBy'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function OrganizationLinkedPropertyToJSON(json: any): OrganizationLinkedProperty {
    return OrganizationLinkedPropertyToJSONTyped(json, false);
}

export function OrganizationLinkedPropertyToJSONTyped(value?: Omit<OrganizationLinkedProperty, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyId': value['companyId'],
        'streetAddress': value['streetAddress'],
        'unit': value['unit'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'country': value['country'],
        'notes': value['notes'],
        'createdBy': value['createdBy'],
        'role': value['role'],
    };
}

